import { BowlBlock } from '@websolutespa/payload-plugin-bowl';
import { options } from '../../options';
import { withIntegration } from './withIntegration';

export enum KbSitemapOutputFormat {
  Text = 'text',
  HTML = 'html',
  Markdown = 'markdown',
}

export const LlmKbSitemap: BowlBlock = withIntegration(options.slug.llmKbSitemap, [
  {
    name: 'sitemapUrl',
    type: 'withText',
  },
  {
    name: 'filterUrls',
    type: 'text',
    hasMany: true,
  },
  {
    name: 'includeOnlySelector',
    type: 'text',
    hasMany: true,
  },
  {
    name: 'excludeTag',
    type: 'text',
    hasMany: true,
  },
  {
    name: 'excludeClass',
    type: 'text',
    hasMany: true,
  },
  {
    name: 'excludeId',
    type: 'text',
    hasMany: true,
  },
  {
    name: 'restrictDomain',
    type: 'checkbox',
    defaultValue: true,
  },
  {
    name: 'outputFormat',
    type: 'select',
    options: Object.entries(KbSitemapOutputFormat).map(([k, v]) => ({
      value: v,
      label: k,
    })),
    defaultValue: KbSitemapOutputFormat.Text,
  },
]);
